import urls from "global/constants/UrlConstants";
import { getCallParams, getSearchedCallParams, makeCall } from "utils/service";
import {
  CloudFile,
  CloudUploadPayload,
  CloudUploadResponse,
} from "./types";

export const fetchIntegratedServices = async (): Promise<string[]> => {
  const url = urls.GET_SERVICES_INTEGRATED;
  const callParams = await getSearchedCallParams("GET");
  return await makeCall(url, callParams);
};

export const fetchAuthUrls = async (): Promise<Record<string, string>> => {
  const url = urls.CLOUD_STORAGE_AUTH_URL;
  const callParams = await getCallParams("GET");
  return await makeCall(url, callParams);
};

export const exchangeAccessToken = async (
  provider: string,
  code: string,
  state: string,
) => {
  const url = `${urls.CLOUD_STORAGE_ACCESS_TOKEN}/${provider}?code=${encodeURIComponent(
    code,
  )}&state=${encodeURIComponent(state)}`;
  const callParams = await getSearchedCallParams("POST", {});
  return await makeCall(url, callParams);
};

const normalizeFileList = (raw: any): CloudFile[] => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw as CloudFile[];
  if (Array.isArray(raw.files)) return raw.files;
  if (Array.isArray(raw.items)) return raw.items;
  if (Array.isArray(raw.value)) return raw.value;
  if (Array.isArray(raw.data)) return raw.data;
  if (Array.isArray(raw.message)) return raw.message;
  if (typeof raw === "object") {
    const numericKeys = Object.keys(raw).filter((k) => /^\d+$/.test(k));
    if (numericKeys.length > 0) {
      return numericKeys
        .sort((a, b) => Number(a) - Number(b))
        .map((k) => raw[k]);
    }
  }
  return [];
};

export const fetchCloudFiles = async (
  provider: string,
  path: string = "",
): Promise<CloudFile[]> => {
  const url = `${urls.CLOUD_STORAGE_FILES}/${provider}?path=${encodeURIComponent(
    path,
  )}`;
  const callParams = await getCallParams("GET");
  const raw = await makeCall(url, callParams);
  // eslint-disable-next-line no-console
  console.log("[CloudStorage] fetchCloudFiles raw response:", raw);
  return normalizeFileList(raw);
};

export const searchCloudFiles = async (
  provider: string,
  fileName: string,
): Promise<CloudFile[]> => {
  const url = `${urls.CLOUD_STORAGE_SEARCH_FILE}/${provider}`;
  const callParams = await getCallParams("POST", fileName);
  const raw = await makeCall(url, callParams);
  // eslint-disable-next-line no-console
  console.debug("[CloudStorage] searchCloudFiles response:", raw);
  return normalizeFileList(raw);
};

export const uploadCloudFile = async (
  provider: string,
  envelopeId: string,
  payload: CloudUploadPayload,
): Promise<CloudUploadResponse> => {
  const url = `${urls.CLOUD_STORAGE_UPLOAD_FILE}/${provider}/envelopeId/${envelopeId}`;
  const callParams = await getCallParams("POST", payload);
  return await makeCall(url, callParams);
};
